export const SHOPIFY = 'Shopify'
export const MOBILE_APP = 'MobileApp'
export const NONE = 'None'



// WEBPACK FOOTER //
// ./src/constants/integrationType.js